import { create } from "zustand";
import { MenuDto } from "src/dtos/menu/menuDto";

export interface PDAMenuStore {
  selectedMenu: MenuDto | null;
  setSelectedMenu: (menu: MenuDto | null) => void;
  clearSelectedMenu: () => void;
}

/**
 * PDA 메뉴 선택 상태 관리 스토어
 * 사이드바와 MenuContainer에서 공유
 */
const usePDAMenuStore = create<PDAMenuStore>((set) => ({
  selectedMenu: null,
  setSelectedMenu: (menu) => set({ selectedMenu: menu }),
  clearSelectedMenu: () => set({ selectedMenu: null }),
}));

export default usePDAMenuStore;






